module.exports = __webpack_public_path__ + "static/media/pakiet_1200X900_04pileczka.66f1357d.jpg";